<section class="content kyloe-watermark" id="landing-page">
  <ngx-skeleton-loader appearance="circle" class="loading-landing-page-btns" count="3" animation="progress"></ngx-skeleton-loader>
</section>
<div class="token app-loading">
  <div class="bhAuthError" *ngIf="bhAuthError; else elseBlock">
    <span class="material-icons notranslate">error</span>
    <h2>Failed to establish Bullhorn connection</h2>
    <a href="/?dataCentre={{ datacenter }}">Click here to try again.</a>
  </div>
  <ng-template #elseBlock>
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
    </svg>
    <h2>Authenticating with Bullhorn</h2>
  </ng-template>
</div>
<div class="loading-kyloe-logo">
  <img src="/images/kyloe-combined-small.png" width="150" alt="Kyloe Logo">
</div>
